import { deserialize } from 'cerialize'

export class Status {
	@deserialize public name: string
	@deserialize public description: string
}
